import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';

import 'handsontable/dist/handsontable.full.min.css';
import { registerAllModules } from 'handsontable/registry';

import '@fontsource/ibm-plex-sans';
import { ChakraProvider } from '@chakra-ui/react';

import store from 'core/store/createStore';
import MultiLanguagesProvider from 'contexts/MultiLanguagesContext';
import reportWebVitals from './reportWebVitals';

import Router from './router';
import theme from './theme';
import AuthProvider from 'contexts/AuthContext';
import SSOAutoLogout from 'components/SSOAutoLogout';

TagManager.initialize({
  gtmId: 'GTM-W4Z5QP5L',
});

registerAllModules();

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <AuthProvider>
            <MultiLanguagesProvider>
              <Router />
              <SSOAutoLogout />
            </MultiLanguagesProvider>
          </AuthProvider>
        </BrowserRouter>
      </ChakraProvider>
    </Provider>
  </React.StrictMode>,
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
